import React, { useContext } from 'react';
import { FormContainer } from '../common/form/FormContainer';
import FormPanel from '../common/form/FormPanel';
import FormItem from '../common/form/FormItem';
import FormWidget from '../common/form/FormWidget';
import I18n from '../common/i18n/I18n';
import { FormContext } from '../common/form/FormContext';
import { PERSON_FORM_NAMES } from './utils/personConstants';

export default () => {
    const { state } = useContext(FormContext);

    return (
        <FormPanel>
            <FormContainer>
                <FormItem half>
                    <FormWidget label={<I18n token="person.add.first.name" />} name={PERSON_FORM_NAMES.firstName} />
                </FormItem>
                <FormItem half>
                    <FormWidget label={<I18n token="person.add.last.name" />} name={PERSON_FORM_NAMES.lastName} />
                </FormItem>
                <FormItem>
                    <FormWidget label={<I18n token="person.add.email" />} name={PERSON_FORM_NAMES.email} />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
